import { TextInput } from '@uplift/ui-v2';
import { useProfileStyles } from '../styles';

export const NameForm: React.VFC = () => {
  const { classes } = useProfileStyles();

  return (
    <div>
      <TextInput
        label="(Optional)"
        name="preferredName"
        fullWidth
        inputClasses={{ root: classes.maxWidth400 }}
      />
    </div>
  );
};
